// MACHINERY V2 (Stroje) — the tab LOADING skeletons (split out of tabAtoms.tsx
// at M2.16d step 1, near-cap rule).
//
// WHAT IT OWNS: the two static skeleton primitives every profile tab (and the
// katalog detail, and the SR machine card) paints while a list loads.
//
// WHY IT IS SEPARATE: `tabAtoms.tsx` stood at 257 of the project's 300-line cap
// and M2.16d had to change `TabSearch` inside it, so the split is the first task
// rather than the last. The seam is the honest one — everything left in
// tabAtoms is a control or a container the user INTERACTS with, everything here
// is an inert placeholder that renders while there is nothing to interact with.
// It also has the widest consumer set (seven call sites across three folders),
// so it is the piece that most deserves its own name.
//
// SKELETONS ARE STATIC. Artboards 1002 and 1010 draw plain tinted bars with a
// descending opacity ramp and NO shimmer. That is also why nothing here needs a
// keyframe — and, since machinery-v2-tokens.scss:289-292 forces
// `animation: none !important` on every descendant under prefers-reduced-motion,
// a shimmer would simply not run for those users anyway.
//
// No Tailwind, no shadcn, no MUI, no @emotion, no sx, no dt tokens.
import React from "react";

/** One skeleton bar. `dim` drives the artboard descending-opacity ramp. */
export const SkeletonBar: React.FC<{
  height?: number;
  width?: string;
  dim?: number;
  radius?: number;
}> = ({ height = 40, width = "100%", dim = 0, radius = 5 }) => (
  <div
    aria-hidden
    style={{
      height,
      width,
      borderRadius: radius,
      background: "var(--border-soft)",
      opacity: Math.max(0.35, 1 - dim * 0.15),
    }}
  />
);

/** The stack of skeleton bars shown while a list loads (artboard 1002). */
export const SkeletonList: React.FC<{ rows?: number; height?: number }> = ({
  rows = 4,
  height = 40,
}) => (
  <div style={{ display: "flex", flexDirection: "column", gap: 8, padding: 14 }}>
    {Array.from({ length: rows }, (_unused, i) => (
      <SkeletonBar key={i} height={height} dim={i} />
    ))}
  </div>
);
